<template>
    <div
        :class="{zoomed: zoomed}"
        @click="clickHandle"
        class="zoom-box">
        <div class="zoom-box-placeholder" :style="placeholderStyle"></div>

        <div
          ref="overlay"
          class="zoom-box-overlay">
          <div
            ref="modal"
            :class="{hidden}"
            class="zoom-box-modal">
            <div
              ref="zoomBtn"
              :class="{'zoom-in': !zoomed}"
              v-if="!userAgent.device.isMobile"
              class="zoom-box-modal__btn">
              <span ref="zoomBtn2">Zoom </span>
              <span ref="zoomBtn3" v-if="!zoomed">in</span>
              <span ref="zoomBtn4" v-else class="zoom-box-modal__btn--out">out</span>
            </div>
            <div class="zoom-box-modal__content">
              <div class="zoom-box-title">
                <slot name="title"></slot>
              </div>
              <div class="zoom-box-graph">
                <slot name="graph"></slot>
              </div>
              <div class="zoom-box-txt">
                <slot name="txt"></slot>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import { TweenMax, TimelineMax, Power0 } from 'gsap';
import { mapState } from 'vuex';

TweenMax.defaultEase = Power0.easeNone;

let tl = null;
let first = null;

export default {
  data() {
    return {
      zoomed: false,
      hidden: false,
      placeholderHeight: 0
    };
  },
  computed: {
    ...mapState(['userAgent']),
    placeholderStyle() {
      return `height: ${this.placeholderHeight}px`;
    }
  },
  methods: {
    clickHandle(e) {
      if (this.userAgent.device.isMobile) {
        return;
      }

      if (
        e.target === this.$refs.zoomBtn ||
        e.target === this.$refs.zoomBtn2 ||
        e.target === this.$refs.zoomBtn3 ||
        e.target === this.$refs.zoomBtn4 ||
        this.zoomed === false ||
        (this.zoomed === true && e.target === this.$refs.overlay)
      ) {
        this.toggleZoom();
      }
    },
    clickOnOverlay(e) {
      if (this.userAgent.device.isMobile) {
        return;
      }

      if (this.zoomed && e.target === e.currentTarget) {
        this.toggleZoom();
      }
    },
    toggleZoom() {
      if ((tl && !tl.isActive()) || !tl) {
        first = this.$refs.modal.getBoundingClientRect();

        if (!this.zoomed) {
          // if we will zoom
          let overlayRect = this.$refs.overlay.getBoundingClientRect();

          this.placeholderHeight = parseInt(
            overlayRect.bottom - overlayRect.top
          );

          this.hidden = true;

          this.lockScroll();
        } else {
          this.placeholderHeight = 0;
          this.unlockScroll();
        }

        this.zoomed = !this.zoomed;

        this.$nextTick(this.toggleAnimate);
      }
    },
    toggleAnimate() {
      const last = this.$refs.modal.getBoundingClientRect();

      // Invert: determine the delta between the
      // first and last bounds to invert the element
      // const deltaX = first.left - last.left;
      // const deltaY = first.top - last.top;
      const deltaW = first.width / last.width;
      const deltaH = first.height / last.height;

      if (this.hidden) {
        this.hidden = false;
      }

      tl = new TimelineMax();

      tl.fromTo(
        this.$refs.modal,
        0.5,
        {
          transformOrigin: 'bottom left',
          transform: `
            scale(${deltaW}, ${deltaH})
          `
        },
        {
          transform: 'none'
        }
      );

      // translate(${deltaX}px, ${deltaY}px)
    }
  }
};
</script>

<style lang="scss" src="./ZoomBox.scss">
</style>
